/** Search results truncate titles past roughly 70 characters. */
export const MAX_TITLE_LENGTH = 70;

/**
 * Return the first candidate that fits the title budget. Candidates run from
 * most to least specific; the last one is used even when it is still long,
 * because a provider name itself is never cut mid-word.
 */
export function fitTitle(
  candidates: readonly string[],
  maxLength = MAX_TITLE_LENGTH,
): string {
  const usable = candidates.filter((candidate) => candidate.trim().length > 0);
  return (
    usable.find((candidate) => candidate.length <= maxLength) ??
    usable[usable.length - 1] ??
    ""
  );
}

export function providerPageTitle(
  providerName: string,
  primaryDistrict: string | null,
): string {
  return fitTitle([
    ...(primaryDistrict
      ? [
          `${providerName} – hemtjänst i ${primaryDistrict}, Stockholm`,
          `${providerName} – hemtjänst i ${primaryDistrict}`,
        ]
      : []),
    `${providerName} – hemtjänst i Stockholm`,
    `${providerName} – hemtjänst`,
    providerName,
  ]);
}

/**
 * Pagination links for public lists. The journey choice (`resa`) is already
 * stored in the visitor's browser when they arrive with it, so carrying it into
 * every page link only creates crawlable noindex duplicates of the list.
 */
export function listPageHref(
  basePath: string,
  searchParams: URLSearchParams,
  nextPage: number,
  pageSize: number,
  defaultPageSize = 25,
): string {
  const next = new URLSearchParams(searchParams);
  next.delete("resa");
  if (nextPage > 1) next.set("page", String(nextPage));
  else next.delete("page");
  if (pageSize !== defaultPageSize) next.set("pageSize", String(pageSize));
  else next.delete("pageSize");
  const query = next.toString();
  return `${basePath}${query ? `?${query}` : ""}`;
}

export function pageSuffix(page: number, pageCount: number): string {
  return page > 1 ? ` Sida ${page} av ${pageCount}.` : "";
}
